class BookingStore {

	constructor(coachAvailability, bookings) {
		this.coachAvailability = coachAvailability;
		this.bookings = bookings;
		this.selectedTime = null;
		this.selectedDate = null;
	}

	getCoachAvailability() {
		return this.coachAvailability;
	}

	setCoachAvailability(coachAvailability) {
		this.coachAvailability = coachAvailability;
	}

	getBookings() {
		return this.bookings;
	}

	setBookings(bookings) {
		this.bookings = bookings;
	}

	getSelectedTime() {
		return this.selectedTime;
	}

	setSelectedTime(startTime, endTime) {
		this.selectedTime = { startTime, endTime };
	}

	getSelectedDate() {
		return this.selectedDate;
	}

	setSelectedDate(date) {
		this.selectedDate = date;
	}
}

const bookingStore = new BookingStore(null, null);
export default bookingStore;
